import React, { useEffect, useState } from 'react';
import { Divider, Form, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { configManager, useAuthContext } from 'react-structure-admin';
import { ReduxRender } from 'core';
import {
  closeRegularizePayment,
  getCalculationPendingDebits,
  postRegularizePayment,
  SUBSCRIPTION_OPEN_REGULARIZE_PAYMENT
} from 'stores/subscriptions/subscriptionActions';
import { useHistory } from 'react-router-dom';
import { CurrencyDisplay } from 'components';
import Loading from 'components/Loading';
import { formartDateTimeUTC, formatCurrency } from 'util/formatters';
import { billingFrequency } from 'constants/billingFrequency';
import moment from 'moment';

const SubscriptionRegularizePayment = ({ catching, loading }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const { subscription, isAuthenticated, refresh } = useAuthContext();
  const [pendingDebitInfo, setPendingDebitInfo] = useState();

  const handleSuccess = ({ data }) => {
    if (data?.result && isAuthenticated()) {
      refresh();

      const { id } = data.result;
      history.push(`/pay/${id}`);
      handleClose();
    }
  };

  const handleConfirm = () => {
    dispatch(
      postRegularizePayment(subscription.id, pendingDebitInfo, handleSuccess)
    );
  };

  const handleSubmit = () => {
    form.validateFields().then(() => {
      Modal.confirm({
        title: `Será gerada uma fatura no valor de ${formatCurrency(
          pendingDebitInfo?.totalAmount
        )} para regularização da assinatura. Deseja continuar?`,
        width: '500px',
        cancelText: 'Não',
        style: { top: 200 },
        okText: 'Sim',
        onOk: () => handleConfirm()
      });
    });
  };

  const handleClose = () => {
    dispatch(closeRegularizePayment());
  };

  const onSucessGetCalculationPendingDebits = ({ data }) => {
    const { result } = data;
    setPendingDebitInfo(result);
  };

  useEffect(() => {
    if (subscription.totalDaysPendingPayment < 30) {
      history.push(`/pay/${subscription.lastPaymentId}`);
      handleClose();
      return;
    }

    if (
      subscription.lastPaymentDate &&
      moment(subscription.lastPaymentDate).isSame(moment(), 'day')
    ) {
      history.push(`/pay/${subscription.lastPaymentId}`);
      handleClose();
      return;
    }

    dispatch(
      getCalculationPendingDebits(
        subscription.id,
        onSucessGetCalculationPendingDebits
      )
    );
  }, []);

  return (
    <Modal
      visible
      title="Regularizar pagamento"
      okText="Confirmar"
      cancelText="Cancelar"
      confirmLoading={loading}
      onOk={handleSubmit}
      onCancel={handleClose}
    >
      <Form
        form={form}
        {...configManager.getConfig().layout.form}
        validateTrigger={false}
      >
        {catching ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Loading fontSize={32} />
          </div>
        ) : (
          <div className="gx-mb-1">
            <Divider orientation="left">Débitos</Divider>
            <table className="gx-checkoutplan-summary gx-ml-3">
              <tbody>
                {pendingDebitInfo?.debits?.map((debit, index) => (
                  <tr key={index}>
                    <td style={{ width: 450 }}>
                      Plano {subscription?.planName} -{' '}
                      {billingFrequency[subscription?.planFrequency]} (
                      {formartDateTimeUTC(debit.dueDate, 'DD/MM/YYYY')})
                    </td>
                    <td className="gx-text-right">
                      <CurrencyDisplay
                        amount={debit.originalAmount}
                        hideValueEqualToZero={false}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Divider className="gx-mt-2 gx-mb-2" />

            <table className="gx-ml-3">
              <tbody>
                <tr>
                  <td style={{ width: 470 }}>Subtotal</td>
                  <td className="gx-text-right">
                    <CurrencyDisplay
                      amount={pendingDebitInfo?.subTotal}
                      hideValueEqualToZero={false}
                    />
                  </td>
                </tr>
                {pendingDebitInfo?.totalInterest > 0 && (
                  <tr>
                    <td style={{ width: 470 }}>Juros</td>
                    <td className="gx-text-right">
                      <CurrencyDisplay
                        amount={pendingDebitInfo?.totalInterest}
                        hideValueEqualToZero={true}
                      />
                    </td>
                  </tr>
                )}
                {pendingDebitInfo?.totalPenalty > 0 && (
                  <tr>
                    <td style={{ width: 470 }}>Multa</td>
                    <td className="gx-text-right">
                      <CurrencyDisplay
                        amount={pendingDebitInfo?.totalPenalty}
                        hideValueEqualToZero={true}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <Divider className="gx-mt-2 gx-mb-2" />

            <table className="gx-ml-3">
              <tbody>
                <tr>
                  <td
                    style={{ width: 470 }}
                    className="gx-fs-xl gx-font-weight-semi-bold"
                  >
                    Total
                  </td>
                  <td className="gx-text-right">
                    <CurrencyDisplay
                      className="gx-font-weight-semi-bold"
                      amount={pendingDebitInfo?.totalAmount}
                      hideValueEqualToZero={false}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default ReduxRender.create(SubscriptionRegularizePayment, {
  condition: (state) =>
    state.resources?.subscriptions?.activeModal ==
    SUBSCRIPTION_OPEN_REGULARIZE_PAYMENT,
  mapProps: (state) => ({
    catching: state.resources?.subscriptions?.catching,
    loading: state.resources?.subscriptions?.loading
  })
});
